import { cx } from '@emotion/css';
import { AccountHolderEmploymentStatusDto } from 'src/dtos';
import { MFormTextField, MTypography } from 'src/lib';
import { AccountHolder } from 'src/models';
import { Color, Spacing } from 'src/styles';

export interface FinancialInformationEmploymentViewProps {
  accountHolder?: AccountHolder;
  testId?: string;
}

export const FinancialInformationEmploymentView = ({
  accountHolder,
  testId,
}: FinancialInformationEmploymentViewProps) => {
  const isEmployed = () =>
    accountHolder?.financialInformation?.employmentStatus?.value === AccountHolderEmploymentStatusDto.Employed;

  return (
    <>
      <MFormTextField
        label='Employment Status'
        value={accountHolder?.financialInformation?.employmentStatus?.label}
        testId={`${testId}-account-employment-status`}
      />
      {isEmployed() && (
        <>
          <MFormTextField
            label='Employer Name'
            value={accountHolder?.financialInformation?.employerName}
            testId={`${testId}-account-employer-name`}
          />
          <MFormTextField
            label='Job Title'
            value={accountHolder?.financialInformation?.jobTitle}
            testId={`${testId}-account-job-title`}
          />
          <MFormTextField
            label='Years Employed'
            value={accountHolder?.financialInformation?.yearsEmployed?.label}
            testId={`${testId}-account-years-employed`}
          />
          <MTypography variant='h5' weight='bold' color={Color.Gray8} className={cx(Spacing.mb32, Spacing.mt40)}>
            Employment Address
          </MTypography>
          <MFormTextField
            label='Address Line 1'
            value={accountHolder?.financialInformation?.employerAddress?.address1}
            testId={`${testId}-account-mailing-address1`}
          />
          <MFormTextField
            label='Address Line 2 (Opt.)'
            value={accountHolder?.financialInformation?.employerAddress?.address2}
            testId={`${testId}-account-mailing-address2`}
          />
          <MFormTextField
            label='Country'
            value={accountHolder?.financialInformation?.employerAddress?.country?.label}
            testId={`${testId}-account-mailing-country`}
          />
          <MFormTextField
            label='City'
            value={accountHolder?.financialInformation?.employerAddress?.city}
            testId={`${testId}-account-mailing-city`}
          />
          <MFormTextField
            label='State'
            value={accountHolder?.financialInformation?.employerAddress?.state?.label}
            testId={`${testId}-account-mailing-state`}
          />
          <MFormTextField
            label='Postal Code'
            value={accountHolder?.financialInformation?.employerAddress?.postalCode}
            testId={`${testId}-account-mailing-postal-code`}
          />
        </>
      )}
    </>
  );
};
